import { combineReducers } from 'redux';

const elements = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default combineReducers({
  elements
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/toolbox-reducers.js